import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { CUSTOM_LAYOUT_WRAPPER_ID } from '@constants/layout.ts';
import {
    ContentLayoutWrapper,
    LayoutWrapper,
    MainContentLayoutWrapper,
    MainLayoutWrapper,
} from '@layouts/main/___shared___/styled.tsx';

import { MainContent } from '../content';
import { MainHeader } from '../header';
import MainSider from '../sider/main-sider';

interface CombinedMainLayoutProps {
    // If true, wraps Outlet in the “custom” content wrapper
    custom?: boolean;
    // layout won't get empty space on both sides and content will not have fixed 1478px width on bigger screens (> 1920px)
    fullWidth?: boolean;
}

const addMainLayoutClassToBodyTag = () => document.body.classList.add('main-layout');

const MainLayout: React.FC<CombinedMainLayoutProps> = ({ custom = false, fullWidth = false }) => {
    useEffect(() => {
        // will hide redundant vertical scroll and rely on internal scroll from components
        addMainLayoutClassToBodyTag();
    }, []);

    return (
        <LayoutWrapper $fullWidth={fullWidth}>
            <MainHeader />
            <MainLayoutWrapper id={custom ? CUSTOM_LAYOUT_WRAPPER_ID : undefined}>
                <MainSider />
                <MainContentLayoutWrapper>
                    {custom ? (
                        <ContentLayoutWrapper>
                            <Outlet />
                        </ContentLayoutWrapper>
                    ) : (
                        <MainContent />
                    )}
                </MainContentLayoutWrapper>
            </MainLayoutWrapper>
        </LayoutWrapper>
    );
};

export default MainLayout;
